
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"100%","height":"100%","viewBox":"0 0 20 20","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.66602 4.16667C1.66602 3.24619 2.41221 2.5 3.33268 2.5H16.666C17.5865 2.5 18.3327 3.24619 18.3327 4.16667V15.8333C18.3327 16.7538 17.5865 17.5 16.666 17.5H3.33268C2.41221 17.5 1.66602 16.7538 1.66602 15.8333V4.16667Z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M7.5 14.1663V5.83301L14.1667 9.99967L7.5 14.1663Z","fill":"#141414"}})])
          )
        }
      }
    